export default {
  data: () => ({ identi: "hoalaadasdahoalaadasdahoalaadasdahoalaadasda" })
};
